import React from 'react';
import { Link } from "react-router-dom";
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';


const Login = () => {
    return (
        <>
            <SEO title="" />
            <main className="page-wrapper">
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />

                {/* Start Slider Area  */}
                <div className='login-bg1' style={{backgroundImage:"url('/images/bg/bg-login.png')"}}>
                    <div className="slider-area slider-style-1 variation-default height-850 bg_image" style={{backgroundImage:"url('/images/bg/bg-login-2.png')",backgroundSize:"400px",backgroundRepeat:"no-repeat",backgroundPosition:"0%"}} data-black-overlay="1" >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4">

                                </div>
                                <div className='col-lg-4 col-sm-12 login-section'>
                                    <h1 className="login-title mt-5">Sign into your account</h1>
                                    <form className="contact-form-2" action="" >
                                        <div className="form-group">
                                            <label>Email</label>
                                            <input type="email" name="email" placeholder="Your Email Address" required />
                                        </div>

                                        <div className="form-group">
                                            <label>Password</label>
                                            <Link to="/forgot-password" className='login-text' style={{float:'right',fontWeight:'bold',fontSize:'14px'}}>Forget password ?</Link>
                                            <input type="password" name="password" placeholder="Your Password" required/>
                                        </div>

                                        <div className="form-group">
                                            <button className="btn-default btn-small" style={{width:"100%"}}>Confirmer</button>
                                        </div> 

                                        {/* <div className="form-group">
                                            {result ? <Result /> : null}
                                        </div>  */}
                                    </form>
                                    <div className='text-center login-text'>
                                        <p>You do not have an account ? <Link to="/register" className='login-text' style={{fontWeight:'bold'}}>Register</Link></p>
                                    </div>
                                </div>
                                <div className='col-lg-4'>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}
              
                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default Login
